import { Button, Card, Form, Row, Input, Modal, message } from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { config as _c, Block, app, api, use } from 'xadmin'
import { SchemaForm } from 'xadmin-form';
import { C, Icon, Loading } from 'xadmin-ui';
import { loginForm, mobileloginForm } from '../schema';
import LogoComponent from './LogoComponent';
import { DeleteOutlined, EditOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'
import sha1 from 'crypto-js/sha1'
import "./login.css"
const DefaultLayout = props => {
  const { children, invalid, handleSubmit, showCode, submitting } = props;
  const { _t } = app.context;
  return (
    <Form onSubmit={handleSubmit} layout="vertical">
      <Card style={{ marginTop: 0, borderTop: 'none', color: '#333' }}>
        {children.filter(c => showCode == true || c.key != 'code')}
        <Row>
          <Button type="primary" loading={submitting} className="loginBtn" disabled={invalid} onClick={handleSubmit} htmlType="submit">{_t('Login')}</Button>
        </Row>
      </Card>
    </Form>
  );
}

const Login = props => {
  const { showCode, showExtra, onSubmit } = use('auth.login', props)
  const [dashboard, setDashboard] = React.useState({})
  const [loading, setLoading] = React.useState(false)
  const [schemaType, setSchemaType] = React.useState('account')
  const [messages, setMessages] = React.useState(false)
  const [premessage, setPreMessage] = React.useState(false)
  const { type } = props
  const { settings } = use('settings')
  const { user } = use('auth.user')
  const [isModalOpen, setIsModalOpen] = useState();
  const [oldPassword, setoldPassword] = useState();
  const [roleId, setroleId] = useState();
  const [oldUsername, setoldUsername] = useState();
  const [tips, setTips] = useState()

  const url = window.location.hash
  const regex = /redirect=([^&]+)/;
  const match = url.match(regex);
  const redirectValue = match ? decodeURIComponent(match[1]) : null;

  const nousername = settings.userExpand?.nousername
  const { errorMessage } = use('redux', state => {
    return { errorMessage: state.errorMessage }
  })
  let showCodesetting = type == 'front' ? settings?.notShowCode : settings?.notShowCodeAdmin

  const createStyleElement = url => {
    const style = document.createElement('style')
    style.type = 'text/css'
    style.innerHTML = `body .setGuideCard{ background-image:url(${url}) }`
    document.getElementsByTagName('HEAD').item(0).appendChild(style)
  }
  React.useEffect(() => {
    if (settings) {
      settings.backgroundImage && createStyleElement(settings.backgroundImage)
    }
  }, [settings])
  React.useEffect(() => {
    console.log(type);
    if (type == 'front') {
      setLoading(true)
      api({ name: 'core/auth/login/dashboard' })
        .fetch('', {})
        .then(({ json }) => {
          let rectption_login_page = _c('isMobile') ? json?.mobilePage?.rectption_login_page : (json?.customPage?.rectption_login_page || json?.rectption_login_page)
          rectption_login_page && setDashboard(rectption_login_page)
          setLoading(false)
        })
        .catch(err => {
          setLoading(false)
        })
    }
  }, [])

  let passwordLength = settings?.passwordLength
  let schema = _.cloneDeep(loginForm)
  let mobileloginSchema = _.cloneDeep(mobileloginForm)
  schema.properties.password.maxLength = passwordLength?.max
  schema.properties.password.minLength = passwordLength?.min
  mobileloginSchema.properties.password.maxLength = passwordLength?.max
  mobileloginSchema.properties.password.minLength = passwordLength?.min

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const onLogin = (v) => {
    return onSubmit(v).then(({ needChangePwd, password, id, username }) => {
      setIsModalOpen(needChangePwd)
      setoldPassword(password)
      setoldUsername(username)
      setroleId(id)
    })
  }
  const handleSubmit = async values => {
    try {
      await api(app.get('models').User).save({
        ...values, id: roleId, password: sha1(values.password).toString(),
        password2: sha1(values.password2).toString()
      }, true)
      message.success('修改密码成功')

      if (roleId == user?.userId) {
        setIsModalOpen(false)
        // app.go('/login')
        window.location.reload()
      }
    } catch (err) {
      return (err.formError || err.json)
    }
  }
  const PasswordInput = ({ input }) => {
    const onChange = (e) => {
      const password = e.target?.value
      input.onChange(password)
    }

    return (
      <>
        <Input.Password
          type="password" name="password" autocomplete="new-password" value={input.value} onChange={onChange}
          onBlur={input.onBlur}
          iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
        {
          messages ? <div style={{ color: "red" }}>{tips}</div> : null
        }
      </>

    )
  }

  const changePassword = {
    type: "object",
    properties: {
      password: {
        type: "string",
        title: "新密码",
        fieldType: 'password'
      },
      password2: {
        type: "string",
        title: "再次输入新密码",
        fieldType: 'password'
      },
    },
    required: ['password', 'password2'],
    form: [
      {
        key: 'password', attrs: { type: 'password' },
        // validate: value => (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合'),
        validate: (value, values) => {
          if (value) {
            if (nousername && value.includes(oldUsername)) {
              return '密码不能包含用户名';
            }

            if (value == oldPassword) {
              return '密码与原密码不能重复';
            }
          }
          return (/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')
        },
        component: (props) => <PasswordInput {...props} />
      },
      {
        key: 'password2', attrs: { type: 'password' },
        validate: (value, { password }) => value == password ? ((/^(?![^a-zA-Z]+$)(?!\D+$)/ig.test(value) ? null : '密码必须为字母与数字组合')) : '两次输入密码不一致',
      },
    ]
  }

  const DefaultModalLayout = props => {
    const { children, invalid, handleSubmit, showCode, submitting } = props;
    return (
      <Form layout="vertical">
        <Card style={{ marginTop: 0, borderTop: 'none', color: '#333' }}>
          {children.filter(c => showCode == true || c.key != 'verifyCode')}
          <Row>
            <Button type="submit" loading={submitting} onClick={handleSubmit} disabled={invalid} htmlType="submit">修改密码</Button>
          </Row>
        </Card>
      </Form>
    );
  }
  console.log(schemaType == 'account');
  const element = <div className="setGuideCard">

    <div className="guideContent" style={{ width: '648px', margin: '0 auto', borderRadius: '5px' }}>
      <div style={{ maxWidth: '688px', background: 'rgba(255,255,255,.1)', padding: '28px' }}>
        <div style={{ maxWidth: '648px', background: 'rgba(255,255,255,.26)', padding: '28px' }}>
          <div className="loginGuide" >
            <div className="loginBox">
              <LogoComponent {...props}></LogoComponent>
            </div>
            {/* {errorMessage ? <span style={{ display: 'flex', justifyContent: 'center', color: '#ff4d4f' }}>{errorMessage}</span> : null} */}
            <SchemaForm
              formKey={'setLoginGuide'}
              schema={schemaType == 'account' ? schema : mobileloginSchema}
              component={DefaultLayout}
              group={C('Form.SimpleGroup')}
              onSubmit={onLogin}
              showCode={!showCodesetting ? showCode : false}
              initialValues={redirectValue == '/systemSettingThird' ? { username: 'admin' } : {}}
            />
            {false && <div className="loginBox">
              {/* <p><span className="span-middle"></span><span className="span-login">第三方登录</span><span className="span-middle"></span></p> */}
              <div className="login-way-box">
                <div className="login-way">
                  <a className={"login-desc" + (schemaType == 'account' ? '' : ' login-select')} onClick={() => setSchemaType('account')}>账号登录</a>
                </div>
                <div className="login-way">
                  <a className={"login-desc" + (schemaType == 'mobile' ? '' : ' login-select')} onClick={() => setSchemaType('mobile')}>手机登录</a>
                </div>
              </div>
              <p className="goReg" onClick={() => app.go('/reg')}>还没账号，去注册 <Icon type="arrow-right" /></p>
            </div>}
            {showExtra ? (<div className="loginBox">
              <p><span className="span-middle"></span><span className="span-login">第三方登录</span><span className="span-middle"></span></p>
              <div className="login-way-box">
                <div className="login-way">
                  <img src={require('./../images/weixin.png')} alt="" />
                  <p className="login-desc">微信登录</p>
                </div>
                <div className="login-way">
                  <img src={require('./../images/QQ.png')} alt="" />
                  <p className="login-desc">QQ登录</p>
                </div>
              </div>
              <p className="goReg" onClick={() => app.go('/reg')}>还没账号，去注册 <Icon type="arrow-right" /></p>
            </div>) : null}
          </div>
        </div>
      </div>
    </div>
  </div>

  return (
    <>
      {
        type == 'front' ? loading ? <Loading /> : !_.isEmpty(dashboard) ?
          <C is="DashboardView" item={dashboard}>
            <C is="DashboardNormalView" />
          </C> : element : element
      }
      <Modal title="修改密码" visible={isModalOpen} footer={null} onOk={handleOk} onCancel={handleCancel} className='modalchange-password'>
        <div>首次登录的用户为了您的账户安全，请先重置您的登录密码</div>
        <SchemaForm
          schema={changePassword}
          onSubmit={handleSubmit}
          formKey={'userChangePassword'}
          component={DefaultModalLayout}
        />
      </Modal>
    </>
  )
}

export default Login
